import axios from 'axios';
import {
    Base64
} from 'js-base64';

import { Tool } from '../utils/utils.js';
// 创建一个自定义的 Axios 实例
console.log("process.env.API_URL:::", process.env.REACT_APP_API_URL)
const http = axios.create({
    baseURL: process.env.REACT_APP_API_URL, // 设置默认的 baseURL
    // 你还可以在这里添加其他的配置，如 headers、timeout 等
    headers: {
        // 'Content-Type': 'multipart/form-data', // 设置默认的 Content-Type
        // 添加其他默认 headers
    },
});
// http.defaults.headers.post['Content-Type'] = 'multipart/form-data';
// http.defaults.headers.post['Accept'] = '*/*';


var CryptoJS = require("crypto-js");

const base64Encode = (string) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(string));
}
const md5Sign = (string, secret) => {
    return CryptoJS.MD5(string + secret);
}

const randomString = (length) => {
    var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i)
        result += str[Math.floor(Math.random() * str.length)];
    return result;
}

const access_key = 'eaiPCuXGIbqMwAzXQCOGOI1rQrk1W6ug';  // 服务端生成的 access_key
const secret_key = 'cVTp8KV0drYS9eHyMFzkiHDpdJsL5CNT';  // 服务端生成的 secret_key

const header = base64Encode(JSON.stringify({
    "alg": "md5",
    "type": "jwt"
}));


let needToken = false;
if (needToken) {
    http.interceptors.request.use(
        (config) => {
            const timestamp = Date.parse(new Date()) / 1000;    // 取时间戳
            let ak = {
                "timestamp": "1713519230",
                "echostr": "n8a9qZNqyLIaTNPR",
                "ak": access_key,
                "paramData": {}
            };
            let params = config.data;
            console.log(config.data)
            //checkparam 需要检验的参数, 长度过长需缩减
            for (let key in params)
                ak.paramData[key] = params[key] && params[key].length > 100 ? params[key].slice(0, 100) : params[key];

            console.log("ak", JSON.stringify(ak));
            const payload = `eyJ0aW1lc3RhbXAiOiIxNzEzNTE5NTQ4IiwiZWNob3N0ciI6ImVJV2dYUDlzQTdhNHFyOHUiLCJhayI6ImVhaVBDdVhHSWJxTXdBelhRQ09HT0kxclFyazFXNnVnIiwicGFyYW1EYXRhIjp7ImxpbWl0IjoiMSJ9fQ==`
            const signature_string = header + '.' + payload;
            console.log('header', header);
            console.log('payload', payload);
            const api_token = signature_string + '.' + md5Sign(signature_string, secret_key);

            config.headers['api-token'] = api_token;
            return config;
        },
        err => {
            return Promise.reject(err)
        }
    )
}

export default http